import DOMPurify from "dompurify";

/**
 * Tags/attributes aligned with Admin UI CKEditor output for the PDF info block
 * (paragraphs, emphasis, lists, links).
 */
const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "ul",
    "ol",
    "li",
    "a",
    "span",
    "div",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "class"],
  ALLOW_DATA_ATTR: false,
};

/**
 * Sanitize HTML for the processed-order ticket print info block.
 * Plain text (no markup) is preserved; unsafe markup is stripped.
 *
 * @param {unknown} raw
 * @returns {string} Safe HTML string, possibly empty after sanitization
 */
export function sanitizeProcessedOrderInfoHtml(raw) {
  if (raw == null) return "";
  const s = String(raw);
  if (s.trim() === "") return "";
  return DOMPurify.sanitize(s, SANITIZE_OPTIONS);
}
